import type { ComponentProps, FC } from 'react'
import { TextButton } from 'react-common'
import { useTranslation } from 'react-i18next'
import { ButtonContainer } from './ButtonContainer/ButtonContainer'

export const ContinueButton: FC<Partial<ComponentProps<typeof TextButton>>> = (props) => {
  const { t } = useTranslation()

  return (
    <ButtonContainer>
      <TextButton data-qa="continue-course-button" size="large" {...props}>
        {t('courseDetails.continueButton')}
      </TextButton>
    </ButtonContainer>
  )
}
